export function makeCharLeftWarning(
  maxLength: number,
  currentLength: number,
): string {
  return `${maxLength - currentLength} characters left`;
}
